<div mat-dialog-title>
    <button mat-dialog-close (click)="cancel()">
        <i class="fa fa-times"></i>
    </button>
</div>

<mat-dialog-content>
    <form>
        <div class="form-container">
          <app-dropdown [options]="tableView$ | async" [valueFormControl]="valueFormControl" [fieldPlaceholder]="'export-template.dialog.select-template' | translate"></app-dropdown>

          <lib-button
                [label]="'export-template.dialog.actions.validate' | translate"
                [gnvDisable]="valueFormControl.invalid"
                (gnvOnClick)="validate()"
            ></lib-button>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="commands-container">
    <lib-button
        [label]="'export-template.dialog.actions.create' | translate"
        (gnvOnClick)="createNewtTemplate()"
        faIconClass="pi pi-plus"
    ></lib-button>
</mat-dialog-actions>
